module.exports = __webpack_public_path__ + "static/19-2976d5ad484397a6df12711b6df04f66.jpg";